import useQuery, { QueryOptions } from 'hooks/useQuery';
import { searchPolicy, searchPolicyReset } from 'store/policies/actions';
import { searchPolicySelector as selector } from 'store/policies/selectors';

const usePolicy = (params: QueryOptions = {}) =>
  useQuery({
    action: searchPolicy,
    resetAction: searchPolicyReset,
    selector,
    ...params,
  });

export default usePolicy;
